import { ref } from 'vue'
import type { Ref } from 'vue'
import { FOOTER_MENU } from '../entities/MenuType'
import { contentCall } from './useMenu'
import type { FooterLinks } from '~~/modules/menu/entities/MenuFooter'

export const useMenuFooter = async () => {
  const data = await contentCall(FOOTER_MENU, false)
  const dataAdapted: FooterLinks = data
  const MenuFooterLinksInstance: Ref<FooterLinks> = ref(dataAdapted)

  return { MenuFooterLinksInstance }
}
